import React from "react";
import '../../App.css';
import {Container, Form,Col,Button} from 'react-bootstrap';


    class Demographics extends React.Component{
        constructor(props) {
            super(props);

            this.state = {
                DisableEdit:true
            }
        }
        render() {

            if (this.props.action === 'edit') { // ==================FOR EXISTING PATIENT==================
                const patient_data = this.props.items


                const {preventEdit} = this.props
                return (

                    <div>


                        <h4>Demographics</h4> <br/>
                        <Form>
                            <Form.Row>
                                <Col>
                                    <Form.Group>

                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control name="FirstName" onChange={this.props.handler}
                                                      value={patient_data.FirstName || ''} disabled={preventEdit}/>

                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control name="LastName" onChange={this.props.handler}
                                                      value={patient_data.LastName || ''}
                                                      disabled={preventEdit}/>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Age</Form.Label>
                                        <Form.Control name="Age" onChange={this.props.handler} value={patient_data.Age || ''}
                                                      disabled={preventEdit}/>
                                    </Form.Group>
                                </Col>
                            </Form.Row>
                        </Form>

                    </div>
                )
            } else { // ==================FOR NEW PATIENT==================
                const patient_data = this.props.items
                return (
                    <div>


                        <h4>Demographics</h4> <br/>
                        <Form>
                            <Form.Row>
                                <Col>
                                    <Form.Group>

                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control name="FirstName" onChange={this.props.handler}
                                        />

                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control name="LastName" onChange={this.props.handler}/>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Age</Form.Label>
                                        <Form.Control name="Age" onChange={this.props.handler}/>
                                    </Form.Group>
                                </Col>
                            </Form.Row>
                        </Form>

                    </div>
                )
            }
        }
    }

export default  Demographics;